import React from 'react';
import FieldsList from '../FieldsStep/FieldsList';

const FieldsTab = () => {
  return <FieldsList isReadOnly />;
};

export default FieldsTab;
